import React from 'react';

import useTheme from '../SharedUtils/hooks';
import Headline from '../SharedUtils/renderFields/headline';
import Panel from './panel';

import './style.css';

const ExpansionPanel = (props) => {
  const { isLight } = useTheme();
  const widgetClassList = ['o-widget', 'c-expansion-panel', 'no-border'];

  if (isLight) {
    widgetClassList.push('is-light-theme');
  }

  return (
    <div
      id={`c-` + props.rendering?.uid}
      className={widgetClassList.join(' ')}
      data-widget="ExpansionPanel"
    >
      <Headline className="c-expansion-panel-headline" {...props}></Headline>
      {props.fields.PanelItemList.map((item) => (
        <Panel key={item.id} isLight={isLight} {...item}></Panel>
      ))}
    </div>
  );
};
export default ExpansionPanel;
